import type {
  CreditTransactionsReq,
  CreditTransactionsRes,
  ProfileReq,
  ProfileRes,
  RechargeCreditsReq,
  RechargeCreditsRes,
  RefreshTokenReq,
  RefreshTokenRes,
  RegisterReq,
  RegisterRes,
  UserQRCodeRes,
  WechatLoginReq,
  WechatLoginRes,
} from './types';
/**
 * 用户信息相关接口
 */
import { get, post } from '@/utils/request';

/** 获取用户信息 */
export const profile = (params?: ProfileReq) => get<ProfileRes>('/v1/user/profile', { params });

// 手机号登录已移除，项目只使用微信授权登录

/** 统一登录接口 */
export const login = (data: WechatLoginReq, showToast = true) => post<WechatLoginRes>('/v1/user/login', {
  data,
  custom: { auth: false, toast: showToast },
});

/** 静默登录 (兼容别名) */
export const silentLogin = (data: { code: string }) => login({ ...data, silent: true }, false);

/** 用户注册（新用户自动赠送50积分并升级为付费用户） */
export const register = (data: RegisterReq) => post<RegisterRes>('/v1/user/register', {
  data,
  custom: { auth: false },
});

/** 邀请码注册（已简化，不再需要兑换码） */
export const registerWithCode = register;

/** 刷新token */
export const refreshToken = (data: RefreshTokenReq) => post<RefreshTokenRes>('/v1/user/refresh', {
  data,
  custom: { auth: false },
});

/** 充值积分 */
export const rechargeCredits = (data: RechargeCreditsReq) => post<RechargeCreditsRes>('/v1/user/credits/recharge', { data });

/** 获取积分交易记录 */
export const getCreditTransactions = (params?: CreditTransactionsReq) => get<CreditTransactionsRes>('/v1/user/credits/transactions', { params });

/** 获取用户微信小程序码 */
export const getUserQRCode = () => get<UserQRCodeRes>('/v1/user/qrcode');
